<template>
  <div>
    <base-header type="white">
      <template #default>
        <h1 class="text-dark mb-0"><i class="fas fa-boxes mr-2"></i>Inventory Dashboard</h1>
        <p class="text-dark-20 mb-0">Manage devices, companies, and batches</p>
      </template>
    </base-header>

    <b-container fluid class="mt--6">
      <b-row class="app-grid mt-3">
        <b-col lg="4" md="6" class="mb-4" v-for="card in cards" :key="card.title">
          <div class="glass-card" @click="$router.push(card.route)">
            <div class="app-icon"><i :class="[card.icon, 'fa-3x']"></i></div>
            <h5 class="font-weight-bold">{{ card.title }}</h5>
            <p class="text-muted small">{{ card.description }}</p>
            <span class="app-badge">{{ card.badge }}</span>
          </div>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
  name: 'InventoryDashboard',
  computed: {
    ...mapState('inventory', ['devices', 'companies', 'batches']),
    cards() {
      return [
        { title: 'Devices', icon: 'fas fa-tablet-alt', description: 'View all devices, track their location and status', route: '/devices', badge: this.devices.length + ' devices' },
        { title: 'Companies', icon: 'fas fa-building', description: 'Manage external partners and see their devices', route: '/companies', badge: this.companies.length + ' companies' },
        { title: 'Batches', icon: 'fas fa-boxes', description: 'Delivery batches and factory information', route: '/batches', badge: this.batches.length + ' batches' },
        { title: 'Scanner', icon: 'fas fa-camera', description: 'Scan device barcodes with your camera', route: '/scan', badge: 'Mobile' },
        { title: 'Import', icon: 'fas fa-upload', description: 'Import devices from Excel or CSV', route: '/import', badge: 'Batch' },
        { title: 'Settings', icon: 'fas fa-cog', description: 'Manage dropdowns and data lists', route: '/settings', badge: 'Admin' }
      ]
    }
  },
  mounted() {
    this.$store.dispatch('inventory/loadDevices')
    this.$store.dispatch('inventory/loadCompanies')
    this.$store.dispatch('inventory/loadBatches')
  }
}
</script>

<style scoped>
.glass-card {
  background: #ffffff;
  border: 1px solid rgba(0,0,0,0.05);
  border-radius: 28px;
  padding: 2rem 1.5rem;
  cursor: pointer;
  box-shadow: 0 12px 24px -8px rgba(0,0,0,0.08);
  transition: transform 0.25s, box-shadow 0.3s, border-color 0.2s;
  text-align: center;
  height: 100%;
}
.glass-card:hover {
  transform: translateY(-8px);
  box-shadow: 0 24px 36px -12px rgba(17,205,239,0.25);
  border-color: #11CDEF;
}
.app-icon { margin-bottom: 1.5rem; color: #11CDEF; }
.app-badge {
  padding: 0.5rem 1.2rem;
  font-weight: 500;
  letter-spacing: 0.3px;
  border-radius: 30px;
  background: rgba(17,205,239,0.12);
  color: #11CDEF;
  display: inline-block;
  margin-top: 1rem;
  font-size: 0.85rem;
}
</style>